import { colors, RadioGroup, Toggle } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const StepSectionStyled = styled.div`
  padding: 3rem 0 2.5rem;
  border-bottom: 1px solid ${colors.neutral[300]};
`;

export const StepBottomSectionStyled = styled.div`
  padding: 3rem 0 0;
`;

export const ToggleStyled = styled(Toggle)`
  margin-bottom: 2rem;
`;

export const ContentWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 0 0 6rem;
`;

export const RadioGroupStyled = styled(RadioGroup)`
  padding: 2rem 0;
`;
